export default __webpack_public_path__ + "static/desk-img-77ed12404dc617562818bfd53056569e.png";